import { addChildUidsToPcbNode } from "./addNodes";
import { removeChildUidsFromNode } from "./removeNodes";
export const reparentNode = (pcbNodes, nodeToReparent, newParentUid) => {
    const newParentNode = pcbNodes[newParentUid];
    const oldParentUid = nodeToReparent.parentUid;
    if (!newParentNode) {
        /* eslint-disable no-console */
        console.error("Trying to reparent to a non-existed node", nodeToReparent, newParentUid);
        return;
    }
    // Update parent uid
    nodeToReparent.parentUid = newParentUid;
    // Remove child uid from old parent
    removeChildUidsFromNode(pcbNodes, oldParentUid, [nodeToReparent.uid]);
    // Add child uid to new parent
    addChildUidsToPcbNode(newParentNode, [nodeToReparent.uid]);
};
//# sourceMappingURL=reparentNode.js.map